import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';

import { SharedModule } from '../../shared';
import {
  D3Service,
  TimelineService,
  MultiGraphService,
  KeysPipe,
  KnowDescPipe,
  ConquerDescPipe,
  BreatheEasyDescPipe
} from './shared';
import { TimelineComponent } from './timeline.component';
import { TimelineGraphComponent } from './timeline-graph/timeline-graph.component';
import { IndicatorComponent } from './timeline-graph/indicator/indicator.component';
import { LineTooltipComponent } from './timeline-graph/line-tooltip/line-tooltip.component';
import { NotiTooltipComponent } from './timeline-graph/noti-tooltip/noti-tooltip.component';
import { GlobalTooltipComponent } from './timeline-graph/global-tooltip/global-tooltip.component';
import { XAxisComponent } from './timeline-graph/x-axis/x-axis.component';
import { YAxisComponent } from './timeline-graph/y-axis/y-axis.component';
import { LineListComponent } from './timeline-graph/line-list/line-list.component';
import { DottedLineComponent } from './timeline-graph/dotted-line/dotted-line.component';
import { MouseEventComponent } from './timeline-graph/mouse-event/mouse-event.component';
import { AirnoteDialogComponent } from './timeline-graph/airnote-dialog/airnote-dialog.component';
import { BigDotComponent } from './timeline-graph/big-dot/big-dot.component';
import { SmallDotComponent } from './timeline-graph/small-dot/small-dot.component';
import { LegendComponent } from './legend/legend.component';
import { InfoPopupComponent } from './timeline-graph/info-popup/info-popup.component';

import { MyDateRangePickerModule } from 'mydaterangepicker';

@NgModule({
  imports: [
    SharedModule,
    MyDateRangePickerModule
  ],
  exports: [
    TimelineComponent,
    TimelineGraphComponent
  ],
  declarations: [
    TimelineComponent,
    TimelineGraphComponent,
    IndicatorComponent,
    LineTooltipComponent,
    XAxisComponent,
    YAxisComponent,
    LineListComponent,
    DottedLineComponent,
    MouseEventComponent,
    KeysPipe,
    AirnoteDialogComponent,
    BigDotComponent,
    SmallDotComponent,
    NotiTooltipComponent,
    GlobalTooltipComponent,
    LegendComponent,
    InfoPopupComponent,
    KnowDescPipe,
    ConquerDescPipe,
    BreatheEasyDescPipe
  ],
  providers: [
    D3Service,
    TimelineService,
    MultiGraphService,
    DatePipe
  ],
  entryComponents: [
    AirnoteDialogComponent
  ]
})

export class TimelineModule { }
